import { createSelector } from 'reselect'

const getPlayList = (state) => state.playList
const getPlayQueue = (state) => state.playQueue
const getGlobal = (state) => state.global

export const getPlaylistData = createSelector(
  [getPlayList, getPlayQueue, getGlobal],
  (playList, playQueue, global) => ({
    sort: playList.sort,
    loading: playList.loading,
    playlists: playList.playLists,
    searchToken: playList.searchToken,
    totalItemsCount: playList.totalItemsCount,
    isIpadView: global.isIpadView,
    page: playList.page,
    queueItems: playQueue.items
  })
)
